import { render } from "./ProjectAssignUser.vue?vue&type=template&id=425bf9d4&scoped=true"
import script from "./ProjectAssignUser.vue?vue&type=script&lang=js"
export * from "./ProjectAssignUser.vue?vue&type=script&lang=js"

import "./ProjectAssignUser.vue?vue&type=style&index=0&id=425bf9d4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-425bf9d4"

export default script